import request from '@/utils/request'

export function getWebContext(data) {
    return request({
        url: '/api/WebContext/getWebContext',
        method: 'POST'
    })
}